import moment from 'moment-timezone'
import { createContext, useContext, useMemo, useState } from 'react'
import { useTimer } from 'react-timer-hook'

type ITimerContext = {
  start: (value: Date, callback: () => void) => void
  stop: () => void
  restart: (value: Date, callback?: () => void) => void
  isRunning: boolean
  seconds: number
}

const TimerContext = createContext<ITimerContext>({
  start: (value: Date, callback: () => void) => {},
  stop: () => {},
  restart: (value: Date, callback?: () => void) => {},
  isRunning: false,
  seconds: -1
})

export const TimerProvider = ({ children }: any) => {
  const [callback, setCallback] = useState<() => void>()
  const { seconds, isRunning, pause, restart } = useTimer({
    autoStart: false,
    expiryTimestamp: moment().add(600, 'second').toDate(),
    onExpire: () => {
      if (callback) {
        callback()
      }
    }
  })

  const props = useMemo(
    () => ({
      start: (value: Date, cb: () => void) => {
        setCallback(cb || callback)
        restart(value, true)
      },
      stop: () => pause(),
      restart: (value: Date, cb?: () => void) => {
        setCallback(cb || callback)
        restart(value, true)
      },
      isRunning,
      seconds
    }),
    [seconds, isRunning]
  )

  return <TimerContext.Provider value={props}>{children}</TimerContext.Provider>
}

export const useTimerContext = () => useContext(TimerContext)
